// Matrix Rain Background Effect
export function createMatrixRain() {
	const matrixBg = document.querySelector('.matrix-bg');
	const chars = '01';
	const fontSize = 14;
	const columns = Math.floor(window.innerWidth / fontSize);

	const canvas = document.createElement('canvas');
	canvas.width = window.innerWidth;
	canvas.height = window.innerHeight;
	canvas.style.position = 'fixed';
	canvas.style.top = '0';
	canvas.style.left = '0';
	canvas.style.zIndex = '-2';
	canvas.style.opacity = '0.1';

	const ctx = canvas.getContext('2d');
	ctx.font = fontSize + 'px Fira Code';
	ctx.fillStyle = '#00FF41';

	const drops = [];
	for (let i = 0; i < columns; i++) {
		drops[i] = 1;
	}

	function drawMatrix() {
		ctx.fillStyle = 'rgba(0, 0, 0, 0.05)';
		ctx.fillRect(0, 0, canvas.width, canvas.height);

		ctx.fillStyle = '#00FF41';
		for (let i = 0; i < drops.length; i++) {
			const text = chars[Math.floor(Math.random() * chars.length)];
			ctx.fillText(text, i * fontSize, drops[i] * fontSize);

			if (drops[i] * fontSize > canvas.height && Math.random() > 0.975) {
				drops[i] = 0;
			}
			drops[i]++;
		}
	}

	matrixBg.appendChild(canvas);
	setInterval(drawMatrix, 100);

	// Resize handler
	window.addEventListener('resize', () => {
		canvas.width = window.innerWidth;
		canvas.height = window.innerHeight;
	});
}

// Glitch Effects
export function initGlitchEffects() {
	const glitchElements = document.querySelectorAll('.ascii-art pre');

	glitchElements.forEach(element => {
		element.addEventListener('mouseenter', () => {
			element.classList.add('glitch');
			element.setAttribute('data-text', element.textContent);

			setTimeout(() => {
				element.classList.remove('glitch');
			}, 500);
		});
	});

	// Random glitch on terminal title
	const terminalTitle = document.querySelector('.terminal-title');
	if (terminalTitle) {
		setInterval(() => {
			if (Math.random() > 0.95) {
				terminalTitle.style.textShadow =
					'2px 0 #ff0080, -2px 0 #00bfff';
				setTimeout(() => {
					terminalTitle.style.textShadow = 'none';
				}, 100);
			}
		}, 1000);
	}
}

// Particle System for Background
export function initParticleSystem() {
	const particleContainer = document.createElement('div');
	particleContainer.style.position = 'fixed';
	particleContainer.style.top = '0';
	particleContainer.style.left = '0';
	particleContainer.style.width = '100%';
	particleContainer.style.height = '100%';
	particleContainer.style.pointerEvents = 'none';
	particleContainer.style.zIndex = '-1';
	document.body.appendChild(particleContainer);

	function createParticle() {
		const particle = document.createElement('div');
		particle.style.position = 'absolute';
		particle.style.width = '2px';
		particle.style.height = '2px';
		particle.style.backgroundColor = '#00FF41';
		particle.style.boxShadow = '0 0 10px #00FF41';
		particle.style.borderRadius = '50%';
		particle.style.opacity = Math.random();

		const startX = Math.random() * window.innerWidth;
		const startY = Math.random() * window.innerHeight;
		particle.style.left = startX + 'px';
		particle.style.top = startY + 'px';

		particleContainer.appendChild(particle);

		const duration = 3000 + Math.random() * 2000;
		const endX = startX + (Math.random() - 0.5) * 200;
		const endY = startY + (Math.random() - 0.5) * 200;

		particle.animate(
			[
				{
					left: startX + 'px',
					top: startY + 'px',
					opacity: particle.style.opacity,
				},
				{
					left: endX + 'px',
					top: endY + 'px',
					opacity: 0,
				},
			],
			{
				duration: duration,
				easing: 'ease-out',
			}
		).onfinish = () => {
			particle.remove();
		};
	}

	// Create particles periodically
	setInterval(createParticle, 500);
}

// Enhanced Project Card Hover Effects
export function initProjectCardEffects() {
	const projectCards = document.querySelectorAll('.project-card');

	projectCards.forEach(card => {
		card.addEventListener('mouseenter', () => {
			// Add scan line effect
			const scanLine = document.createElement('div');
			scanLine.style.position = 'absolute';
			scanLine.style.top = '0';
			scanLine.style.left = '0';
			scanLine.style.width = '100%';
			scanLine.style.height = '2px';
			scanLine.style.background =
				'linear-gradient(90deg, transparent, #00FF41, transparent)';
			scanLine.style.animation = 'scan 1s ease-in-out';
			card.appendChild(scanLine);

			setTimeout(() => scanLine.remove(), 1000);
		});
	});

	// Add scan animation
	const scanStyle = document.createElement('style');
	scanStyle.textContent = `
        @keyframes scan {
            0% { top: 0; opacity: 1; }
            100% { top: 100%; opacity: 0; }
        }
    `;
	document.head.appendChild(scanStyle);
}